import { render, staticRenderFns } from "./AnalitPropEdit.vue?vue&type=template&id=989464e2&scoped=true"
import script from "./AnalitPropEdit.vue?vue&type=script&lang=js"
export * from "./AnalitPropEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989464e2",
  null
  
)

export default component.exports